// extracted by mini-css-extract-plugin
export default {"wrapper":"LicenseKeyInput_wrapper__iuhnl","label":"LicenseKeyInput_label__mlduG","input":"LicenseKeyInput_input__m2iFg","hint":"LicenseKeyInput_hint__CZ+ci"};